<p-table [value]="allAccounts" dataKey="id">
    <ng-template pTemplate="header">
        <tr>
            <th style="max-width: 3rem"></th>
            <th>Name</th>
            <th>Financial Statement</th>
            <th>Group</th>
            <th>Is Default</th>
            <th>Action</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-product let-expanded="expanded">
        <tr class="parentRow">
            <td class="action">
                <button type="button" [pRowToggler]="product" pButton pRipple class="p-button-text p-button-rounded p-button-plain" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" *ngIf="product.childAccounts && product.childAccounts.length > 0" style="width: 20px;height: 20px;"></button>
            </td>
            <td>{{product?.displayNumber}} {{product.name}}</td>
            <td>{{product?.financialStatement?.name}}</td>
            <td>{{product?.parentFinancialAccountId != 0 && product.subAccountType ? product.subAccountType.name : ''}}</td>
            <td></td>
            <td></td>
        </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-product>
        <ng-container *ngFor="let child of product.childAccounts">
            <tr>
                <td style="padding-left: 2rem !important;" class="action">
                    <button type="button" pButton pRipple (click)="child.toggle=!child.toggle;child.subExpanded=!child.subExpanded" class="p-button-text p-button-rounded p-button-plain" [icon]="child.subExpanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" *ngIf="child.childAccounts && child.childAccounts.length > 0"
                        style="width: 20px;height: 20px;"></button>
                </td>
                <td style="padding-left: 2rem !important;">{{child?.displayNumber}} - {{child.name}}</td>
                <td>{{child?.financialStatement?.name}}</td>
                <td>{{child.subAccountType?child.subAccountType.name:''}}</td>
                <td>
                    <p-radioButton [value]="true" [(ngModel)]="child.isDefault" (onClick)="updateAccount($event,child)"></p-radioButton>
                </td>
                <td class="action">
                    <span *ngIf="child?.createdSource != 'system'" class="btnBars p-mr-0" (click)="showEditAccount(product,child)" pTooltip="Edit" tooltipPosition="top"><i class="pi pi-pencil"></i></span>
                    <span class="btnBars p-mr-0" *ngIf="child.createdSource!='system' && child.childAccounts?.length < 1 && !child.isDefault" (click)="checkAccount(product,child)" pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
                </td>
            </tr>
            <ng-container *ngIf="child.toggle">
                <tr *ngFor="let sub of child.childAccounts">
                    <td></td>
                    <td style="padding-left: 3rem !important;">{{sub?.displayNumber}} - {{sub.name}}</td>
                    <td>{{sub?.financialStatement?.name}}</td>
                    <td>{{sub.subAccountType?sub.subAccountType.name:''}}</td>
                    <td>
                        <p-radioButton [value]="true" [(ngModel)]="sub.isDefault" (onClick)="updateAccount($event,sub)"></p-radioButton>
                    </td>
                    <td class="action">
                        <span *ngIf="sub?.createdSource != 'system'" class="btnBars p-mr-0" (click)="showEditAccount(product,child,sub)" pTooltip="Edit" tooltipPosition="top"><i class="pi pi-pencil"></i></span>
                        <span *ngIf="sub?.createdSource != 'system' && !sub.isDefault" class="btnBars p-mr-0" (click)="checkAccount(product,child,sub)" pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
                    </td>
                </tr>
            </ng-container>
        </ng-container>
    </ng-template>
</p-table>

<app-add-edit-finance-account-modal [allAccounts]="allAccounts" [addEditChartHeader]="addEditChartHeader" [displayAddEditChart]="displayAddEditFinanceAccount" [addEditDialogType]="addEditDialogType" [editAccountData]="editAccountData" (onCancel)="onCancelAccount()"
    (onSuccessfullAddEdit)="onSuccessfullAccountAddEdit($event)"></app-add-edit-finance-account-modal>

<p-dialog header="Delete Account" [(visible)]="displayAccountAvailability" [modal]="true" [responsive]="true" [style]="{width: '60vw'}">
    <div class="header">
        <h5>Delete Warning</h5>
    </div>
    <div class="card">
        <span style="font-weight: bold;">This Account is associated with below Multiple Products</span><br>
        <span>{{associatedProducts}}</span>
    </div>
</p-dialog>